import { IDashboardComponent, IDashboardMetadata, IDashboardSort } from '../dashboard-metadata.service';
import { LARGE_QUOTE_KPI, REPORT_4_MAPPINGS, USER_APPROVAL_COLUMNS } from './shared-dashboard.config';
import { NumberOfFansInfoComponent } from '../info/number-of-fans-info.component';
import { CustomerDashboardFiltersComponent } from '../filters/customer/customer-dashboard-filters.component';
import { DateType } from '../../../../shared/services/date.util';
import { VALIDATOR_FN_GBDM } from '../dashboard.service';
import { RoleContactType } from '../../../../shared/contact/role-contact-type';

const customerColumns:string[] = [
  'Delamcn',
  'Desprst_ds',
  'Desprnm',
  'Detimes',
  'Detimam',
  'Deoppor_ds',
  'Decatav_ds',
  'Delamst_ds',
  'Dewinch_ds',
  'Deforus',
  'Dedecdt',
  'Destadt',
  'Deopeni',
  'Decatdt',
  'Destaco',
  'Delamcm',
  'Delamnm'
];

const ALL_WEBSHOP_TYPE_EXCL_DEMO_BP: string = 'ADHOC,CEPP,P2P,REFRESH,SERVICES,SPECIAL,STEADY,DAAS,RMA';

const REPORT_4_SORT_BY_COUNTRY_HIT_RATE:IDashboardSort = {
  name: 'Countryhitratepercentage',
  direction: 'desc'
};

const NUMBER_OF_FANS_INFO_COMPONENT:IDashboardComponent = {
  name: NumberOfFansInfoComponent
};

export const GBDM_DASHBOARD_CONFIG:IDashboardMetadata = {
  title: 'GBDM KPI',
  filterComponent: {
    name: CustomerDashboardFiltersComponent,
    inputs: {
      preselectGbdm: true,
      showLamContact: true,
      preselectLamContact: true,
      preselectLamCompany: true,
      validatorFn: VALIDATOR_FN_GBDM
    }
  },
  mapping: {
    Desprnm: 'customer.id',
    Cucomid: 'customerCompany.id',
    Delamnm: 'lam.id',
    Lacomnm: 'lamCompany.id',
    Lacgrid: 'lamGroup.id',
    Gblname: 'gbdm.id',
    Decounm: 'country.id',
    Devincl: 'vatIncl.id',
    Delamcn: 'lamContact.id'
  },
  fixedFilters: {
    Devincl: '0'
  },
  reports: [
    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'MY_CUSTOMER_WITH_OPEN_ORDERS',
      comments: '',
      fixedFilters: {
        Deopeni: '>0',
        Deopenp: '1',
        Deorder: 'Delamcn, Desprnm'

      },
      mapping: REPORT_4_MAPPINGS,
      columns: customerColumns
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'MY_CUSTOMER_WITHOUT_OPEN_ORDERS',
      comments: '',
      fixedFilters: {
        Desprst_ds: '@ACT@@CLOSED@@PRESALES@@STEADY@@TOAPPROVE@',
        Deopeni: '0',
        Deopenp: '1',
        Deorder: 'Delamcn, Desprnm'

      },
      mapping: REPORT_4_MAPPINGS,
      columns: customerColumns
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'MY_SLEEP_WEBSHOPS',
      comments: '',
      fixedFilters: {
        Desprst_ds: '@SLEEP@'

      },
      mapping: REPORT_4_MAPPINGS,
      columns: [
        'Delamcm',
        'Delamnm',
        'Delamcn',
        'Desprnm',
        'Desprdt',
        'Desprst_ds',
        'Destaco',
        'Deopeni',
        'Desprds',
        'Degbdmn'
      ]
    },

    {
      id: 108,
      key: 'MY_RECENT_MAILS',
      comments: '',
      fixedFilters: {
        Demaidt_FROM: DateType.YESTERDAY,
        Demymai: '1'

      },
      mapping: {
        Delname: 'gbdm.firstname + " " + gbdm.lastname'
      },
      columns: [
        'Deview',
        'Destate_ds',
        'Delname',
        'Wvmaito',
        'Rpsubje',
        'Dereqid',
        'Desprnm',
        'Deccoid',
        'Ermaito',
        'Ermaicc',
        'Derepor'
      ]
    },

    {
      id: 257,
      key: 'USERS_TO_APPROVE_APPROVAL',
      comments: 'Customer or Vendor users with an approver',
      fixedFilters: {
        Decrety_ds: 'SIGNUP',
        Destate_ds: 'WAIT_APRVL',
        Decredt_FROM: '01/01/2018',
        Kpi: 'WITH_APPROVER',
        Dashboard: 'GBDM'
      },
      mapping: {
        Owlname: 'gbdm.id',
        Decomnm: 'customerCompany.id'
      },
      columns: USER_APPROVAL_COLUMNS.concat([ 'Decommt' ])
    },

    {
      id: 257,
      key: 'USERS_TO_APPROVE_NO_APPROVAL',
      comments: 'Customer or Vendor users without an approver',
      fixedFilters: {
        Decrety_ds: 'SIGNUP',
        Destate_ds: 'WAIT_APRVL',
        Decredt_FROM: '01/01/2018',
        Kpi: 'WITHOUT_APPROVER',
        Dashboard: 'GBDM'
      },
      mapping: {
        Owlname: 'gbdm.id',
        Decomnm: 'customerCompany.id'
      },
      columns: USER_APPROVAL_COLUMNS
    },

    {
      id: 222,
      key: 'QUOTES_TO_BE_SENT',
      comments: 'Quotes waiting to be sent',
      fixedFilters: {
        Dereqst: 'ACSL'
      },
      mapping: {
        Decurce: 'currency.id'
      },
      columns: [
        'Devipnr_ds',
        'Dereqid',
        'Decounm',
        'Desubdt',
        'Dersudt',
        'Devaldt',
        'Decommt',
        'Pacomnm',
        'Odlname',
        'Detotal',
        'Actotal',
        'Detotal',
        'Dereqst',
        'Lead_time',
        'Decompa',
        'Delamnm',
        'Lacomnm',
        'Gblname'
      ]
    },

    {
      browselistCode: 'TICKET',
      key: 'OPEN_TICKETS',
      fixedFilters: {
        Deiopen: '1'
      },
      mapping: {
        Shsprnm: 'customer.id',
        Lacgrid: 'lamGroup.id',
        Shlamcm: 'lamCompany.id',
        Shlacom: 'lam.id',
        Shcounm: 'country.id',
        Shgbdmn: 'gbdm.id',
        Shlamcn: 'lamContact.id'
      }
    },

    {
      browselistCode: 'TICKET',
      key: 'CLOSED_TICKETS',
      fixedFilters: {
        Deiopen: '0',
        Dereadt_FROM: DateType.ONE_WEEK_AGO
      },
      mapping: {
        Shsprnm: 'customer.id',
        Lacgrid: 'lamGroup.id',
        Shlamcm: 'lamCompany.id',
        Shlacom: 'lam.id',
        Shcounm: 'country.id',
        Shgbdmn: 'gbdm.id',
        Shlamcn: 'lamContact.id'
      }
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'LOST_WEBSHOPS',
      comments: 'Please complete reason why we lost the opportunity',
      fixedFilters: {
        Desprst_ds: '@CLOSED@',
        Desprdt_real_FROM: DateType.ONE_WEEK_AGO,
        Deopenp: '0'
      },
      mapping: REPORT_4_MAPPINGS,
      columns: [
        'Desprnm',
        'Decredt',
        'Delamcm',
        'Delamcn',
        'Destaco'
      ]
    },

    {
      id: 8,
      key: 'WAITING_LAM_INVOICES',
      comments: '',
      fixedFilters: {
        Invoicecategory: 'LAMFEES',
        Delednr: '600110',
        Depayst_ds: '0,1,7,8,-1'
      },
      mapping: {
        Desprid: 'customer.id',
        Degbdmn: 'gbdm.id',
        Decouid: 'country.id'
      },
      columns: [
        'Deinvid',
        'Deownnm',
        'Deinvnr',
        'Deinvdt',
        'Submit_date',
        'Paytobank_iban',
        'Paytobank_swift',
        'Detotal',
        'Ivcurce',
        'Depayst_ds',
        'Deperio',
        'Decommt'
      ]
    },

    {
      id: 120,
      key: 'BP_WITH_PROBLEMS',
      comments: ' ',
      fixedFilters: {
        Debp_ok_ds: '>0',
        Excludedemo: 1
      },
      mapping: {
        Lacomnm: 'lam.id',
        Delamcm: 'lamCompany.id',
        Degbdmn: 'gbdm.id',
        Decntce: 'country.id'
      },
      columns: [
        'Desprnm',
        'Deconti',
        'Decntce',
        'Devendo',
        'Debp_ok_ds',
        'Pacomnm',
        'Destaco_sh',
        'Decover_sh',
        'Delamcm',
        'Delamcn',
        'Lacomnm',
        'Decodnm'
      ]
    },

    {
      browselistCode: 'WEBSHOP_INFO',
      key: 'WAITING_FOR_CONTRACT',
      comments: '',
      fixedFilters: {
        Contractwaiting: '1'
      },
      mapping: REPORT_4_MAPPINGS,
      columns: [
        'Desprnm',
        'Desprst_ds',
        'Delamcm',
        'Delamcn',
        'Culname',
        'Destadt',
        'Destaco',
        'Deinvty_ds',
        'Deitych_ds',
        'Delamor_ds'
      ]
    },

    {
      id: 33,
      key: 'LAM_CONTACTS_STATUS',
      fixedFilters: {
        Decnyds: RoleContactType.LAM,
        Deproty_ds: ALL_WEBSHOP_TYPE_EXCL_DEMO_BP
      },
      mapping: {
        Cucomnm: 'lam.id',
        Decomnm: 'lamCompany.id',
        Degbdmn: 'gbdm.id',
        Decounm: 'country.id',
        Username: 'lamContact.id',
        Decgrid: 'lamGroup.id',
        Desprnm: 'customer.id'
      },
      columns: [
        'Deconid',
        'Defname',
        'Delname',
        'Decomnm',
        'Desprnm',
        {
          name:'Detrast_ds',
          groupingSequence: 1
        },
        'Detradt',
        'Deacslc',
        'Delogdt',
        'Deregdt',
        'Decredt',
        'Rolecreationdate',
        'Dectitl'
      ],
      infoComponent: NUMBER_OF_FANS_INFO_COMPONENT
    },
    {
      id: 33,
      key: 'CGAM_CONTACT_STATUS',
      comments: '',
      fixedFilters: {
        Decnyds: RoleContactType.CGAM,
        Deproty_ds: ALL_WEBSHOP_TYPE_EXCL_DEMO_BP
      },
      mapping: {
        Lam: 'lam.id',
        Lamcompany: 'lamCompany.id',
        Lamcontact: 'lamContact.id',
        Lamgroup: 'lamGroup.id',
        Desprnm: 'customer.id',
        Degbdmn: 'gbdm.id',
        Desk: 'gbdmDesk.id'
      },
      columns: [
        'Deconid',
        'Defname',
        'Delname',
        'Decomnm',
        'Desprnm',
        {
          name:'Detrast_ds',
          groupingSequence: 1
        },
        'Detradt',
        'Deacslc',
        'Delogdt',
        'Deregdt',
        'Decredt',
        'Rolecreationdate',
        'Dectitl'
      ],
      infoComponent: NUMBER_OF_FANS_INFO_COMPONENT
    },
    {
      id: 173,
      key: 'CGAM_MISSING',
      comments: '',
      fixedFilters: {
        Denorol: RoleContactType.CGAM,
        Deproty_ds: ALL_WEBSHOP_TYPE_EXCL_DEMO_BP
      },
      mapping: {
        Delamco: 'lamCompany.id',
        Desk: 'gbdmDesk.id',
        Gblname: 'gbdm.id',
        Lacounm: 'country.id',
        Lamgroup: 'lamGroup.id',
        Desprnm: 'customer.id',
        Decusid: 'customerCompany.id'
      }
    },
    {
      id: 211,
      key: 'WRONG_CURRENCY_ORDERS',
      comments: '',
      fixedFilters: {
        Dedate1: DateType.YESTERDAY,
        Detestr_ds: '0',
        Dewaspq: 0,
        Deordcu2_ok: 0
      }
    },
    {
      id: 223,
      key: 'PENDING_B2B_NON_CATALOG',
      comments: '',
      fixedFilters: {
        Dereqst: 229 // pending b2b - non catalog request
      },
      mapping: {
        Desk: 'gbdmDesk.id'
      },
      columns: [
        'Devipnr_ds',
        'Dereqid_ds',
        'Depornr',
        'Pending_date',
        'Age',
        'Dereqst',
        'Owner_type',
        'Owner',
        'Decommt',
        'Decompa',
        'Decounm',
        'Detotal',
        'Actotal',
        'Desubdt',
        'Odlname',
        'Pacomnm',
        'Delamnm',
        'Lacomnm',
        'Delamcn',
        'Decsunm',
        'Decomds',
        'Customer_kpi_section',
        'Kpi_dashboard_name',
        'Gblname',
        'Desk',
        'Deetadt',
        'Doityourself_ds',
        'Oddesk',
        'Vnam',
        'Vrep',
        'Debpref',
        'Dedvref',
        'Deveref',
        'Stocktype',
        'Denamnm'
      ]
    },
    {
      id: 96,
      key: 'MASTER_SERVICE_PACK',
      comments: '',
      fixedFilters: {
        Decalst: 'ALLOPEN',
        Decomds: 248, // Master Service Pack
        Deorddt_FROM: null
      },
      mapping: {
        Delamco: 'lamCompany.id',
        Desk: 'gbdmDesk.id'
      }
    },
    {
      id: 175,
      key: 'COUNTRY_HIT_RATE',
      fixedFilters: {
        Deordpr_ds: '',
        Displaycontacts: 'GAM',
        Losprst_ds: 'PRIORITY'
      },
      mapping: {
        Decusid: 'customerCompany.id',
        Delamco: 'lamCompany.id',
        Delamnm: 'lam.id'
      },
      columns: [
        'Webshopsetup',
        'Desprnm',
        'Decounm',
        'Pacomnm',
        'Deexpoy',
        'Detotal',
        'Detotlo',
        'Losprst_ds',
        'Lostaco',
        'Losprdt',
        'Denrusr',
        'Deordpr_ds',
        'Icprodt',
        'Deucnok',
        'Delamcn',
        'Cglname',
        'Gblname',
        'Improdt',
        'Derqbco',
        'Desprst_ds',
        'Destaco',
        'Deordga_ds'
      ]
    },
    {
      browselistCode: 'QUOTE_EDIT',
      key: 'LARGE_QUOTES',
      fixedFilters: LARGE_QUOTE_KPI.fixedFilters,
      mapping: {
        Degbdmn: 'gbdm.id',
        Delamco_ds: 'lam.id',
        Delamnm: 'lamContact.id',
        Desk: 'gbdmDesk.id'
      },
      columns: LARGE_QUOTE_KPI.columns,
      sort: LARGE_QUOTE_KPI.sort
    },
    {
      id: 33,
      key: 'CUSTOMER_REFERENCE',
      comments: '',
      fixedFilters: {
        Decnyds: 'CREFERENCE',
        Deproty_ds: ALL_WEBSHOP_TYPE_EXCL_DEMO_BP
      },
      mapping: {
        Lam: 'lam.id',
        Lamcompany: 'lamCompany.id',
        Lamcontact: 'lamContact.id',
        Lamgroup: 'lamGroup.id',
        Desprnm: 'customer.id',
        Degbdmn: 'gbdm.id',
        Desk: 'gbdmDesk.id'
      },
      columns: [
        'Deconid',
        'Defname',
        'Delname',
        'Desprnm',
        'Delogdt',
        {
          name:'Detrast_ds',
          groupingSequence: 1
        },
        'Rolecreationdate',
        'Decounm',
        'Degrpnm',
        'Dectitl'
      ],
      infoComponent: NUMBER_OF_FANS_INFO_COMPONENT
    },
    {
      id: 4,
      key: 'GBDM_CUSTOMER_HIT_RATE_PERCENTAGE',
      storedReport: 'GBDM_CUSTOMER_HIT_RATE_PERCENTAGE',
      mapping: REPORT_4_MAPPINGS,
      sort: [REPORT_4_SORT_BY_COUNTRY_HIT_RATE]
    },
    {
      id: 101,
      key: 'AUTOMATIC_REPORTS_BY_GBDM',
      storedReport: 'AUTOMATIC_REPORTS_BY_GBDM',
      mapping: {
        Desprnm: 'customer.id',
        Decomnm: 'customerCompany.id',
        Degbdmn: 'gbdm.id',
        Desk: 'gbdmDesk.id'
      }
    },
    {
      id: 4,
      key: 'CUSTOMERS_IN_SPOTLIGHT',
      storedReport: 'CUSTOMERS_IN_SPOTLIGHT',
      mapping: REPORT_4_MAPPINGS
    },
    {
      id: 48,
      key: 'GBDM_SUCCESS_STORIES',
      storedReport: 'GBDM_SUCCESS_STORIES',
      mapping: {
        Desprnm: 'customer.id',
        Decomnm: 'customerCompany.id',
        Lalamnm: 'lam.id',
        Lalamcm: 'lamCompany.id',
        Gblname: 'gbdm.id',
        Lalname: 'lamContact.id'
      }
    }
  ]
};